import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

/**
 * Поиск деталей при создании новой заявки на компенсацию.
 */
export default class extends Controller {
  static get targets() {
    return ['input', 'parts'];
  }

  initialize() {
    this.timeout = null;
    this.renderedArticle = null;
  }

  connect() {
    this.partId = parseInt(this.data.get('part_id'));
    this.userId = parseInt(this.data.get('user_id'));
    this.offerId = parseInt(this.data.get('offer_id'));

    this.inputTarget.addEventListener('change', () =>
      this.searchParts()
    );
    this.inputTarget.addEventListener('keydown', () =>
      this.searchParts()
    );
    this.inputTarget.addEventListener('paste', () =>
      this.searchParts()
    );

    if (this.inputTarget.value.length > 0) {
      this.searchParts();
    }
  }

  disconnect() {
    this.inputTarget.removeEventListener('change', () =>
      this.searchParts()
    );
    this.inputTarget.removeEventListener('keydown', () =>
      this.searchParts()
    );
    this.inputTarget.removeEventListener('paste', () =>
      this.searchParts()
    );
  }

  checkSelectedPart() { }

  renderLoader() {
    this.partsTarget.innerHTML = `<br><div class="loader is-pulled-left"></div>&nbsp;Ищем деталь в нашей базе...`;
  }

  renderNotFound(article) {
    this.partsTarget.innerHTML = `<br><p class="content is-paddingless">Деталь «${article}» не найдена в нашей базе.</p>`;
  }

  renderPart(part) {
    if (part.satisfies) {
      const checked = this.partId === part.id;

      return `
        <div class="control">
          <label class="radio">
            <input type="radio" name="compensation[part_id]" value="${part.id}" ${
        checked ? 'checked' : ''
        }>
            ${part.brand} ${part.article} ${part.description}
          </label>
        </div>
      `;
    } else {
      return `
        <div class="control">
          <label class="radio has-text-line-through" title="Деталь не соответствует условию для компенсации">
            ${part.brand} ${part.article} ${part.description}
          </label>
        </div>
      `;
    }
  }

  renderParts(parts) {
    let result = [];
    const simpleParts = [];
    for (const part of parts) {
      simpleParts.push(this.renderPart(part));
    }

    if (simpleParts.length > 0) {
      if (result.length > 0) result.push('<br>');

      result.push(`
      <br><p class="has-text-weight-bold">Выберите деталь из списка:</p>
      `);
      result = [...result, ...simpleParts];
    }

    this.partsTarget.innerHTML = result.join('');

    this.checkSelectedPart();
  }

  searchParts() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const article = this.inputTarget.value;
      const userId = this.userId;
      const offerId = this.offerId;
      if (article.length > 2 && article !== this.renderedArticle) {
        this.renderLoader();

        const that = this;
        Rails.ajax({
          type: 'GET',
          url: `/compensations/search_parts.json?query=${article}&user_id=${userId}&offer_id=${offerId}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderParts(data);
            } else {
              that.renderNotFound(article);
            }

            that.renderedArticle = article;
          },
          error: () => {
            alert('Ошибка при попытке найти детали по вашему запросу');
          },
        });
      }
    }, 400);
  }
}
